const endpoints = {
  getBallotForMashList: 'mashlist/{id}/ballot',
  vote: 'mashlist/{id}/vote',
  addContender: 'mashlist/{id}/add-contender',
  getMashList: 'mashlist/{id}',
  deleteContender: 'mashlist/contender/{id}',
  renameContender: 'mashlist/contender/{id}/rename',
  uploadContenderImage: 'mashlist/contender/{id}/upload-image',
  deleteMashList: 'mashlist/{id}',
  renameMashList: 'mashlist/{id}/rename',
  getAllMashList: 'mashlist/list',
  getMyMashLists: 'mashlist/my-lists',
  createMashList: 'mashlist/create',
  getShortKey: 'shortkey/{id}',
  login: 'auth/login',
  register: 'auth/register',
  confirmEmail: 'auth/confirm-email',
  forgotPassword: 'auth/forgot-password',
  resetPassword: 'auth/reset-password',
};

export default endpoints;
